import React, { useEffect, useContext, useState } from 'react';
import AddCourse from './AddCourse';
import AddTeacher from './AddTeacher';
import { A } from 'hookrouter';
import { DataContext as CovDataStore } from '../../store';
import CreateReport from './CreateReport';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { EXL_NAV_MENU_BACK_BUTTON, EXL_NAV_MENU_COURSES_BUTTON, EXL_NAV_MENU_REPORTS_BUTTON, EXL_NAV_MENU_TEACHERS_BUTTON } from '../../i18n/keyConstants';


const ExlNavMenu = ({ type }) => {

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { store: covStore } = useContext(CovDataStore);
    const user = covStore?.user;
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const { t } = useTranslation(['exlNavMenu']);

    const determineClass = (buttonType) => {
        return `btn btn-light ${type === buttonType ? 'active' : ''}`;
    }

    return (
        <>
            {(user.isAdmin || user.isExlAdmin) ? (
                <div className='crm-navbar padding-top-10px padding-bottom-10px padding-left-10px padding-right-10px d-flex justify-content-between align-items-center'>

                    <div className='d-flex'>
                        <button className='btn btn-outline-secondary d-flex c-dark-blue border-0' onClick={() => window.history.back()}>
                            <span className='oi oi-chevron-left padding-right-10px'></span>
                            <span className='d-none d-sm-block'>{t(EXL_NAV_MENU_BACK_BUTTON)}</span>
                        </button>
                        {type === 'ExlCourses' ? <AddCourse /> : null}
                        {type === 'ExlTeachers' ? <AddTeacher /> : null}
                        
                    </div>
                    <div className='d-inline-flex align-items-center position-sticky' style={{ right: 10, zIndex: 900 }}>
                        <div className='btn-group'>
                            <A href='/exlCourses' className={determineClass('ExlCourses')}>
                                {t(EXL_NAV_MENU_COURSES_BUTTON)}
                            </A>
                            <A
                                href='/exlTeachers'
                                className={determineClass('ExlTeachers')}>
                                {t(EXL_NAV_MENU_TEACHERS_BUTTON)}
                            </A>
                            <Button variant="info" onClick={() => setReportModalOpen(true)} className="btn btn-light">{t(EXL_NAV_MENU_REPORTS_BUTTON)}</Button>
                            <CreateReport open={reportModalOpen} onClose={() => setReportModalOpen(false)} />
                        </div>
                    </div>
                </div>
            ) : (

                <div className='crm-navbar padding-top-10px padding-bottom-10px padding-left-10px padding-right-10px d-flex justify-content-between align-items-center'>

                    <div className='d-flex'>
                        <button className='btn btn-outline-secondary d-flex c-dark-blue border-0' onClick={() => window.history.back()}>
                            <span className='oi oi-chevron-left padding-right-10px'></span>
                            <span className='d-none d-sm-block'>{t(EXL_NAV_MENU_BACK_BUTTON)}</span>
                        </button>
                    </div>
                    <div className='d-inline-flex align-items-center position-sticky' style={{ right: 10, zIndex: 900 }}>
                        <div className='btn-group'>
                            <A href='/exlCourses' className={determineClass('ExlCourses')}>
                                {t(EXL_NAV_MENU_COURSES_BUTTON)}
                            </A>
                            {(user.isExlCertificateAdmin) ? (
                                <>
                                    <Button variant="info" onClick={() => setReportModalOpen(true)} className="btn btn-light">{t(EXL_NAV_MENU_REPORTS_BUTTON)}</Button>
                                    <CreateReport open={reportModalOpen} onClose={() => setReportModalOpen(false)} />
                                </>
                            ) : <></>}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ExlNavMenu;
